module.exports = __webpack_public_path__ + "img/head-bg.da4bfe55.png";